// @mui icons
import Instagram from "@mui/icons-material/Instagram";

// Collab English components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-collab-enlgish-slogan.svg";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Material Kit 2",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <Instagram />,
      link: "https://www.instagram.com/collab_english/",
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} Collab English by{" "}
      <MKTypography
        component="a"
        href="https://nathandesign.art/"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Nathan Martins
      </MKTypography>
      .
    </MKTypography>
  ),
};
